import { render, staticRenderFns } from "./NewVolunteerFamily.vue?vue&type=template&id=4104992e&scoped=true&"
import script from "./NewVolunteerFamily.vue?vue&type=script&lang=js&"
export * from "./NewVolunteerFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4104992e",
  null
  
)

export default component.exports